const KEY_PREFIX = 'vr_review_session';

type VrReviewSession = {
  reviewSessionId: string;
};

const getStorage = (): Storage | null => {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  return sessionStorage;
};

const getStorageKey = (applicationNumber: string | number) =>
  `${KEY_PREFIX}:${String(applicationNumber)}`;

const createSessionId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

const parseSession = (raw: string | null): VrReviewSession | null => {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<VrReviewSession>;
    if (typeof parsed?.reviewSessionId === 'string' && parsed.reviewSessionId.trim()) {
      return {
        reviewSessionId: parsed.reviewSessionId.trim(),
      };
    }
  } catch {
    // Legacy format: raw string reviewSessionId
  }

  if (raw.trim()) {
    return { reviewSessionId: raw.trim() };
  }
  return null;
};

const persistSession = (storage: Storage, key: string, session: VrReviewSession) => {
  storage.setItem(key, JSON.stringify(session));
};

export const getOrCreateVrReviewSession = (applicationNumber: string | number) => {
  const storage = getStorage();
  if (!storage) {
    return { reviewSessionId: createSessionId() };
  }

  const key = getStorageKey(applicationNumber);
  const session = { reviewSessionId: createSessionId() };
  persistSession(storage, key, session);
  return session;
};

export const getVrReviewSession = (applicationNumber: string | number): VrReviewSession | null => {
  const storage = getStorage();
  if (!storage) {
    return null;
  }
  return parseSession(storage.getItem(getStorageKey(applicationNumber)));
};

export const clearVrReviewSession = (applicationNumber: string | number) => {
  const storage = getStorage();
  if (!storage) {
    return;
  }
  storage.removeItem(getStorageKey(applicationNumber));
};
